import { PushNotifications } from "@capacitor/push-notifications";
import { isNative, platform, pushEnabled } from "@/lib/native";
import { api } from "@/lib/api";

let deviceToken = null;

export async function registerPush(onOpen) {
  if (!isNative || !pushEnabled) return "unavailable";
  const perm = await PushNotifications.requestPermissions();
  if (perm.receive !== "granted") return "denied";
  await PushNotifications.removeAllListeners();
  PushNotifications.addListener("registration", (t) => {
    deviceToken = t.value;
    api.post("/devices", { token: t.value, platform }).catch(() => {});
  });
  PushNotifications.addListener("pushNotificationActionPerformed", (a) => {
    const path = a.notification?.data?.path;
    if (path) onOpen(path);
  });
  await PushNotifications.register();
  return "granted";
}

export async function unregisterPush() {
  if (!deviceToken) return;
  await api.post("/devices/remove", { token: deviceToken, platform }).catch(() => {});
  deviceToken = null;
}
